import { HighlightVideo as HighlightVideo$1 } from '@cbhq/cdx-components';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_VIDEO_CONTENT_MODEL_ID = 'cdxHighlightVideo';
function HighlightVideo({
  mediaUrl,
  thumbnail,
  caption,
  anchor,
  style,
  hasLightbox,
  hasSpacingTop
}) {
  return /*#__PURE__*/jsx(HighlightVideo$1, {
    mediaUrl: mediaUrl,
    thumbnailUrl: thumbnail?.fields.file?.url,
    thumbnailAlt: thumbnail?.fields.title,
    caption: caption,
    anchor: anchor,
    style: style,
    hasLightbox: hasLightbox,
    hasSpacingTop: hasSpacingTop
  });
}
export { HIGHLIGHT_VIDEO_CONTENT_MODEL_ID, HighlightVideo };
//# sourceMappingURL=HighlightVideo.js.map
